// extracted by mini-css-extract-plugin
module.exports = {"modal_btn":"leningdeelgegevens_modal_btn__3cBrX"};